<template>
  <section>
    <div class="main-buttons">
      <div class="row">
        <div
          class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12 align-self-center mb-0"
        >
          <b-form-group class="mb-0">
            <b-input-group size="sm" class="input-search">
              <b-input-group-prepend class="pt-1 pl-1">
                <i class="flaticon-bold-magnifier"></i>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="simpleSearch"
                v-on:input="applySimpleSearch"
                type="search"
                placeholder="Search Anything..."
                class="border-none"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </div>
        <div
          class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
        >
          <div>
            <div class="box-buttons">
              <base-button
                v-if="canUserCreate"
                type="outline-secondary"
                class="min-button mb-2"
                @click="openNewDestiantionModal()"
              >
                <i class="flaticon-plus"></i>
                Assign new destination
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-table">
      <div class="row">
        <div
          class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mt-3"
        ></div>

        <div
          class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center text-right"
        >
          <div class="d-inline-block mr-2">
            <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
              <b-form-radio-group
                id="btn-radios-view"
                v-model="view"
                :aria-describedby="ariaDescribedbyview"
                name="radios-btn-default"
                buttons
                @change="changeViewCard"
                class="mb-0"
                button-variant="outline-neutral pc-3"
              >
                <b-form-radio value="table"
                  ><i class="flaticon-two" title="View Table"></i
                ></b-form-radio>
                <b-form-radio value="card"
                  ><i class="flaticon-menu" title="View Card"></i
                ></b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="d-inline-block mr-2">
            <el-tooltip content="Export" placement="bottom">
              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="div"
                title-tag="a"
                title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                title="Export"
              >
                <base-button slot="title" type="none" class="p-0 min-button">
                  <i class="flaticon-downloading-files mr-0 mt-2"></i>
                </base-button>

                <div
                  class="dropdown-item"
                  @click="download(selectedRows)"
                  v-if="selectedRows.length > 0"
                >
                  Selected Records
                </div>
                <div class="dropdown-item" @click="download([])">
                  All Records
                </div>
              </base-dropdown>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div>
        <pagination-block
          :pageCount="branchesByOperatorId.pages"
          :total="branchesByOperatorId.count"
          :limit="limit"
          @changeLimit="changeLimit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="branches"
          :fields="fields"
          sort-by.sync="name"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == branches.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #cell(name_destination)="data">
            <span
              v-if="canUserUpdate"
              class="capitalize hide-data link"
              @click.stop="openEditDestiantionModal(data.item._id, data.item)"
            >
              {{ data.item.name }}
            </span>
            <span v-else class="capitalize hide-data link">
              {{ data.item.name }}
            </span>
          </template>

          <template #cell(coverage_radius)="data">
            <span class="hide-data">{{ data.item.selection_range }}</span>
          </template>

          <template #cell(coverage_areas)="data">
            <!-- show total coverage areas of the destination -->
            <span class="hide-data">{{
              data.item.areasSummary.affiliate
            }}</span>
          </template>

          <template #cell(rates)="data">
            <!-- show total rates of the destination -->
            <span class="hide-data">{{
              data.item.ratesSummary.affiliate
            }}</span>
          </template>

          <template #cell(actions)="data">
            <el-tooltip content="Edit" placement="bottom">
              <span
                v-if="canUserUpdate"
                class="icon-action"
                @click.stop="openEditDestiantionModal(data.item._id, data.item)"
              >
                <i class="flaticon-pencil text-primary"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="See Coverage Areas" placement="bottom">
              <span
                class="icon-action text-new ml-2"
                @click="$router.push(`/coverage-areas?branch=${data.item._id}`)"
              >
                <i class="flaticon-radar"></i>
              </span>
            </el-tooltip>

            <el-tooltip v-if="canUserViewMap" content="View Map" placement="bottom">
              <span
                class="icon-action text-info ml-2"
                @click="goToDestinationMap(data.item._id)"
              >
                <i class="flaticon-bold-map"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="See Rates" placement="bottom">
              <span
                class="icon-action text-warning ml-2"
                @click="$router.push(`/rates?branch=${data.item._id}`)"
              >
                <i class="flaticon-bold-list"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                v-if="canUserDelete"
                class="icon-action text-danger ml-2"
                @click="deleteBranch(data.item._id)"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>

        <pagination-block
          :pageCount="branchesByOperatorId.pages"
          :total="branchesByOperatorId.count"
          :limit="limit"
          @changeLimit="changeLimit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>

    <NewDestination
      :show="showNewDestinationModal"
      :destinations="destinationsOptions"
      :supplierId="supplierId"
      :assignments="branches.map(branch => branch.destination)"
      @close="closeNewDestiantionModal"
    />
    <EditDestination
      :show="showEditDestinationModal"
      :branchId="tempBranchId"
      :branch="tempBranch"
      @close="closeEditDestiantionModal"
    />
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { BranchesAPI, ExportAPI, DestinationsAPI } from "../../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import NewDestination from "./NewDestination.vue";
import EditDestination from "./EditDestination.vue";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import WSelect from "@/components/Select";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../../helpers/commons.helpers";
import { DESTINATION_MAP_ROLES } from "../../services/map.service";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "DestinationsOperator",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect,
    NewDestination: NewDestination,
    EditDestination: EditDestination
  },
  props: {
    supplierId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedRows: [],
      simpleSearch: "",
      currentPage: 1,
      query: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "name_destination",
          label: "Name",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },

        {
          key: "coverage_radius",
          label: "Coverage Radius",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "coverage_areas",
          label: "Coverage Areas",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "Rates",
          label: "rates",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "90px" }
        }
      ],
      cardview: false,
      view: "table",
      selected: [],
      limit: 0,
      showNewDestinationModal: false,
      destinationsOptions: [],
      tempBranchId: "",
      tempBranch: {},
      showEditDestinationModal: false
    };
  },
  async created() {
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.get(false, this.supplierId, this.limit, this.currentPage, this.query);
    this.destinationsOptions = this.sortByCityName(
      await this.getDestinationsOptions()
    );
  },
  methods: {
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(
          true,
          this.supplierId,
          this.limit,
          this.currentPage,
          this.query
        );
      }
    },
    preventPaginations(page) {
      this.get(true, this.supplierId, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.supplierId, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.supplierId, this.limit, page, this.query);
    },
    async deleteBranch(branchId) {
      let { value } = await Swal.fire({
        title: "Delete Destination",
        text: "Are you sure do you want to delete this Destination?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteBranchById(branchId);
      }
    },
    async deleteBranchById(branchId) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.deleteBranchById(
          branchId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(
            false,
            this.supplierId,
            this.limit,
            this.currentPage,
            this.query
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destination has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Error!. Could not delete the Destination"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "Error!. Could not delete the Destination");
      }
    },
    async deleteManyBranches() {
      let { value } = await Swal.fire({
        title: "Delete Destinations",
        text: "Are you sure do you want to delete the selected Destinations?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyBranchesById(this.selectedRows);
      }
    },
    async deleteManyBranchesById(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.deleteManyBranchesById(
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(
            false,
            this.supplierId,
            this.limit,
            this.currentPage,
            this.query
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destinations has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVBranches(
          this.supplierId,
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `branches-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async get(loader, operatorId, limit, page, query) {
      this.getBranchesByOperatorId({
        operatorId: operatorId,
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    isInSupplierModule(modules = []) {
      if (!(modules.indexOf("suppliers") > -1)) {
        this.setSupplierSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.supplierId, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.supplierId, this.limit, 1, this.query);
        }
      }, 500);
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async getDestinationsOptions() {
      try {
        let { data } = await DestinationsAPI.getDestinationsOptions(
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    sortByCityName(destinations = []) {
      return destinations.sort((a, b) => {
        const firstCity = a.city.toUpperCase();
        const secondCity = b.city.toUpperCase();
        if (firstCity < secondCity) {
          return -1;
        }
        if (firstCity > secondCity) {
          return 1;
        }
        return 0;
      });
    },
    openNewDestiantionModal() {
      this.showNewDestinationModal = true;
    },
    closeNewDestiantionModal(action) {
      this.showNewDestinationModal = false;
      if (action !== "close") {
        this.get(
          true,
          this.supplierId,
          this.limit,
          this.currentPage,
          this.query
        );
      }
    },
    openEditDestiantionModal(branchId, branch) {
      this.tempBranchId = branchId;
      this.tempBranch = branch;
      this.showEditDestinationModal = true;
    },
    /**
     * Open the destination map of a branch (coverage areas + reservations).
     * @param {string} branchId - Branch id of the row.
     */
    goToDestinationMap(branchId) {
      this.$router.push({
        name: "SupplierDestinationMap",
        params: { supplierId: this.supplierId, branchId: branchId }
      });
    },
    closeEditDestiantionModal(action) {
      this.tempBranchId = "";
      this.tempBranch = {};
      this.showEditDestinationModal = false;
      if (action !== "close") {
        this.get(
          true,
          this.supplierId,
          this.limit,
          this.currentPage,
          this.query
        );
      }
    },
    ...mapMutations(["setSigOut", "setLoad", "setSupplierSearchCriteria"]),
    ...mapActions(["getBranchesByOperatorId", "getLimit"])
  },
  computed: {
    branches: function() {
      if (this.branchesByOperatorId.docs) {
        return this.branchesByOperatorId.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "branchesByOperatorId",
      "sesion",
      "userRole",
      "paginationLimit"
    ]),
    canUserDelete() {
      return isUserAuthorized("BRANCHES", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("BRANCHES", this.userRole, "CREATE");
    },
    canUserUpdate() {
      return isUserAuthorized("BRANCHES", this.userRole, "UPDATE");
    },
    /**
     * Only administrative roles can open the destination map (it shows net prices).
     * @returns {boolean}
     */
    canUserViewMap() {
      return DESTINATION_MAP_ROLES.includes(this.userRole);
    }
  }
};
</script>
